exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-pc-components-organisms-EditChoice-___EditChoice__container___2eWt0 {\n  margin: 0 auto;\n}\n\n.src-pc-components-organisms-EditChoice-___EditChoice__section___2thEr {\n}\n\n.src-pc-components-organisms-EditChoice-___EditChoice__flex-container___NnO_j {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.src-pc-components-organisms-EditChoice-___EditChoice__text-flex-container___y0Jv_ {\n  width: 100%;\n}\n\n.src-pc-components-organisms-EditChoice-___EditChoice__button-flex-container___29yvC {\n  width: 14%;\n  padding: 5px 15px 15px 15px;\n}\n", ""]);

// exports
exports.locals = {
	"container": "src-pc-components-organisms-EditChoice-___EditChoice__container___2eWt0",
	"section": "src-pc-components-organisms-EditChoice-___EditChoice__section___2thEr",
	"flex-container": "src-pc-components-organisms-EditChoice-___EditChoice__flex-container___NnO_j",
	"text-flex-container": "src-pc-components-organisms-EditChoice-___EditChoice__text-flex-container___y0Jv_",
	"button-flex-container": "src-pc-components-organisms-EditChoice-___EditChoice__button-flex-container___29yvC"
};